.horizontal-scroller {
  position: relative;
}

.horizontal-scroller__track {
  display: flex;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  list-style: none;
  gap: var(--horizontal-scroller-gap, var(--rc-theme-spacing-xxs));
  scrollbar-width: none;
}

.horizontal-scroller__track::-webkit-scrollbar {
  display: none;
}

.horizontal-scroller__track > * {
  flex: 0 0 auto;
}

.horizontal-scroller--has-previous::before,
.horizontal-scroller--has-next::after {
  position: absolute;
  z-index: 1;
  top: 0;
  width: 48px;
  height: 100%;
  pointer-events: none;
  content: '';
}

.horizontal-scroller--has-previous::before {
  left: 0;
  background: linear-gradient(90deg, var(--rc-theme-color-surface-default) 0%, transparent 100%);
}

.horizontal-scroller--has-next::after {
  right: 0;
  background: linear-gradient(270deg, var(--rc-theme-color-surface-default) 0%, transparent 100%);
}

.horizontal-scroller__arrow:global(.ant-btn) {
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);
  background: color-mix(in srgb, var(--rc-theme-color-primary-default) 6%, var(--rc-theme-color-surface-default));

  &:not(:disabled):is(:hover, :active) {
    background: color-mix(in srgb, var(--rc-theme-color-primary-default) 10%, var(--rc-theme-color-surface-default));
  }
}

.horizontal-scroller__arrow--previous {
  left: 0;
}

.horizontal-scroller__arrow--next {
  right: 0;
}
